import { render, staticRenderFns } from "./VentasPorMes.vue?vue&type=template&id=1737e4e0&scoped=true"
import script from "./VentasPorMes.vue?vue&type=script&lang=js"
export * from "./VentasPorMes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1737e4e0",
  null
  
)

export default component.exports